export const TARIMA = 'Tarima';
export const HALF_TARIMA = '1/2 Tarima';
export const QUARTER_TARIMA = '1/4 Tarima';
export const EIGHTH_TARIMA = 'Mínimo';
